import { ContextMenuItem } from '@/components/ui/context-menu';
import { DESIGNER_INFO_ITEMS } from '@/config/designer-info';
import { copy_text_to_clipboard } from '@/lib/copy-text-to-clipboard';

export function DesignerInfoContextMenuItems() {
  return (
    <>
      {DESIGNER_INFO_ITEMS.map(designer_info_item => (
        <ContextMenuItem
          key={designer_info_item.type}
          onSelect={() => {
            copy_text_to_clipboard(designer_info_item.label);
          }}
        >
          {designer_info_item.label}
        </ContextMenuItem>
      ))}
    </>
  );
}
